import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';

//paginas
import DialogWhatsappConexao from './DialogWhatsappConexao';
import Iconify from 'src/components/Iconify';
import {
  Tabs,
  TabsList,
  TabsTrigger,
} from "src/@/components/ui/tabs";
import { formataNumeroCelular, verifyRules } from 'src/utils/functions';
import Label from 'src/components/Label';
import { useDispatch } from 'react-redux';
import v2_actionEditarCanal from 'src/actions/v2/cliente/canais/v2_actionEditarCanal';
import DialogNewChannel from './DialogNewChannel';
import { useNavigate } from 'react-router';
import v2_actionDeletarCanal from 'src/actions/v2/cliente/canais/v2_actionDeletarCanal';
import getActionClienteByClienteId from 'src/actions/clientes/getActionClienteByClienteId';
import actionListaClientesCanais from 'src/actions/clientes/actionListaClientesCanais';
import getSpent from 'src/actions/clientes/getSpent';
import config from 'src/config';
import { CANAIS_COMPONENT_DESIGN } from './CanaisComponent.design';
import GenericTable from 'src/components/table/GenericTable';
import { GENERIC_TABLE_DESIGN } from 'src/components/table/GenericTable.design';
import { Chip } from '@mui/material';

// ----------------------------------------------------------------------

CanaisComponent.propTypes = {
  canais: PropTypes.array,
  canais: PropTypes.array,
  canaisError: PropTypes.string,
};

const TABLE_HEAD = [
  { id: 'name', label: 'Canal', align: 'left' },
  { id: 'platform', label: 'Plataforma / Detalhes', align: 'left' },
  { id: 'status', label: 'Status', align: 'center' },
  { id: 'actions', label: 'Ações', align: 'right' },
];

const SkeletonCard = () => {
  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6 relative overflow-hidden">
      <div className="flex flex-col space-y-6">
        <div className="flex flex-col items-center justify-center space-y-4">
          <div className="w-12 h-12 bg-gray-100 rounded-lg animate-pulse"></div>
          <div className="w-32 h-4 bg-gray-100 rounded animate-pulse"></div>
        </div>
        <div className="border-t border-dashed border-gray-100"></div>
        <div className="flex flex-col items-center space-y-3">
          <div className="w-24 h-8 bg-gray-100 rounded-lg animate-pulse"></div>
          <div className="w-full h-8 bg-gray-50 rounded-lg animate-pulse"></div>
        </div>
      </div>
    </div>
  );
};

const ErrorCard = ({ message, onRetry }) => {
  return (
    <div className="col-span-full flex flex-col items-center justify-center py-12 px-4 animate-in fade-in slide-in-from-bottom-2 duration-300">
      <div className="bg-red-50 border border-red-100 rounded-xl p-8 max-w-md w-full text-center">
        <div className="flex flex-col items-center space-y-4">
          <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center text-red-500">
            <Iconify icon="solar:danger-circle-bold" width={32} height={32} />
          </div>
          <div>
            <h3 className="text-lg font-semibold text-gray-900 mb-2">Erro ao carregar canais</h3>
            <p className="text-sm text-gray-600 mb-6 leading-relaxed">{message}</p>
            <button
              onClick={onRetry}
              className="bg-white text-red-600 px-6 py-2.5 rounded-xl border border-red-200 text-sm font-semibold hover:bg-red-50 transition-all shadow-sm flex items-center space-x-2 mx-auto"
            >
              <Iconify icon="solar:restart-bold" width={18} height={18} />
              <span>Tentar novamente</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default function CanaisComponent({ user, canais, listaCanais, canaisError, onConfig, onConnect, onButtonLoginFacebook, fbLogin, onCallback }) {
  const navigate = useNavigate()
  const [openNewChannel, setOpenNewChannel] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const [hasError, setHasError] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [spent, setSpent] = useState(null);
  const [viewMode, setViewMode] = useState('card'); // 'card' | 'table'
  const [canalToDelete, setCanalToDelete] = useState(null);

  async function handleGetSpent() {
    const hoje = new Date()
    const inicio = hoje.toISOString().split('T')[0]
    const final = hoje.toISOString().split('T')[0]
    let querys = `?inicio=${inicio}&final=${final}&periodo=mes_atual`
    const response = await getSpent(user.clienteId, querys)
    setSpent(response?.data)
  }

  async function handleDesvincularCanal(canalId) {
    try {
      let data = {
        action: "desvincular_meta_instagram"
      }
      const response = await v2_actionEditarCanal(canalId, data)
      if (response.status === 200) {
        onCallback()
      }
    } catch (error) {
      console.log(error)
    }
  }

  async function handleDesconectarCanal(canalId) {
    try {
      let data = {
        scope: {
          status_connection_whatsapp: "desconectado"
        }
      }
      const response = await v2_actionEditarCanal(canalId, data)
      if (response.status === 200) {
        onCallback()
      }
    } catch (error) {
      console.log(error)
    }
  }

  const handleRetry = async () => {
    setIsLoading(true)
    setHasError(false)
    setErrorMessage('')
    try {
      await handleGetSpent()
      await onCallback()
    } catch (error) {
      setHasError(true)
      setErrorMessage('Erro ao carregar os dados. Verifique sua conexão e tente novamente.')
    } finally {
      setTimeout(() => setIsLoading(false), 1000)
    }
  }

  useEffect(() => {
    const loadData = async () => {
      try {
        await handleGetSpent()
        await onCallback()
      } catch (error) {
        setHasError(true)
        setErrorMessage('Erro ao carregar os dados. Verifique sua conexão e tente novamente.')
      } finally {
        setTimeout(() => setIsLoading(false), 1000)
      }
    }

    loadData()
  }, [])

  useEffect(() => {
    if (canaisError) {
      setHasError(true)
      setErrorMessage(canaisError)
      setIsLoading(false)
    }
  }, [canaisError])

  const channelsUse = spent?.channels?.use;
  const channelsLimit = spent?.channels?.limit;
  const isLimitReached = Number.isFinite(channelsUse) && Number.isFinite(channelsLimit) && channelsUse >= channelsLimit;
  const hasNoPermission = !verifyRules(user.rules, "canal.criar");
  const isBlockedByConfig = !!config.settings.blockChannelUsage;
  const cannotCreateChannel = hasNoPermission || isBlockedByConfig || isLimitReached;
  const blockReason = hasNoPermission
    ? 'Você não tem permissão para criar canais'
    : isBlockedByConfig
      ? 'Criação de canais desabilitada'
      : isLimitReached
        ? 'Limite do plano atingido'
        : null;

  async function renoveAStorageMultisession() {
    const responseCliente = await getActionClienteByClienteId(user.clienteId);
    const response_clientes_canais = await actionListaClientesCanais(user.clienteId);

    let listaNumerosSubs = response_clientes_canais.data.numeros_subs;
    const numeros_subs_reduce = listaNumerosSubs.map((item) => item.nome)

    const newClienteObj = {
      ...responseCliente.data.cliente,
      clientes_canais: responseCliente.data.cliente.multiSession === 1 ? response_clientes_canais.data.data : [],
      numeros_subs: responseCliente.data.cliente.multiSession === 1 ? numeros_subs_reduce : [],
      numeros_subs_data: responseCliente.data.cliente.multiSession === 1 ? listaNumerosSubs : []
    }

    localStorage.setItem('multiSession', responseCliente.data.cliente.multiSession);
    localStorage.setItem('marketplaceId', responseCliente.data.cliente.marketplace_id);
    localStorage.setItem('cliente_data', JSON.stringify(newClienteObj));
  }

  async function handleDeleteCanal(canalId) {
    try {
      const response = await v2_actionDeletarCanal(canalId)
      if (response.status === 200) {
        onCallback();
        renoveAStorageMultisession()
      }
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <div className={CANAIS_COMPONENT_DESIGN.page.container}>

      {/* Header */}
      <div className={CANAIS_COMPONENT_DESIGN.page.header.container}>
        <div>
          <h1 className={CANAIS_COMPONENT_DESIGN.page.header.title}>Canais de Atendimento</h1>
          <p className={CANAIS_COMPONENT_DESIGN.page.header.subtitle}>
            Conecte e gerencie seus pontos de contato com o cliente em um ambiente unificado.
          </p>
        </div>
        <div className="flex items-center gap-4">
          <Tabs value={viewMode} onValueChange={(value) => setViewMode(value)} className="w-full md:w-auto">
            <TabsList className="h-9 bg-gray-100 p-1">
              <TabsTrigger value="card" className="h-7 text-[10px] px-2 data-[state=active]:bg-white data-[state=active]:shadow-sm">
                <Iconify icon="mingcute:card-fill" width={14} className="mr-1" /> Cards
              </TabsTrigger>
              <TabsTrigger value="table" className="h-7 text-[10px] px-2 data-[state=active]:bg-white data-[state=active]:shadow-sm">
                <Iconify icon="mingcute:table-2-fill" width={14} className="mr-1" /> Lista
              </TabsTrigger>
            </TabsList>
          </Tabs>
          <button
            onClick={() => setOpenNewChannel(true)}
            disabled={cannotCreateChannel}
            title={blockReason || ''}
            className={`${CANAIS_COMPONENT_DESIGN.page.actionButton} ${cannotCreateChannel ? 'opacity-50 cursor-not-allowed pointer-events-none' : ''}`}
          >
            <Iconify icon="solar:add-circle-bold" width={20} height={20} />
            <span>Novo Canal</span>
          </button>
        </div>
      </div>

      <DialogNewChannel
        open={openNewChannel}
        onClose={() => setOpenNewChannel(false)}
        onSubmit={(value) => {
          setOpenNewChannel(false)
          navigate({
            pathname: '/dashboard/configuracoes/channelDetails',
            search: '?channelId=' + value + '&new=1'
          });
          onCallback()
          renoveAStorageMultisession()
        }}
      />

      <div className="mt-10">
        {isLoading ? (
          viewMode === 'card' ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 xl:grid-cols-5 gap-6">
              {[...Array(4)].map((_, index) => <SkeletonCard key={index} />)}
            </div>
          ) : (
            <div className="w-full bg-white rounded-xl shadow-sm border border-gray-100 p-6 animate-pulse">
              <div className="h-10 bg-gray-100 rounded mb-4 w-full"></div>
              <div className="space-y-3">
                {[...Array(5)].map((_, i) => (
                  <div key={i} className="h-16 bg-gray-50 rounded w-full"></div>
                ))}
              </div>
            </div>
          )
        ) : hasError ? (
          <ErrorCard message={errorMessage} onRetry={handleRetry} />
        ) : (
          <>
            {viewMode === 'card' ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-6">
                <CardNewChannel
                  onClick={() => setOpenNewChannel(true)}
                  disabled={cannotCreateChannel}
                  blockReason={blockReason}
                />

                {listaCanais && listaCanais.map((item, index) => (
                  <CanalCard
                    key={index}
                    user={user}
                    onDelete={() => handleDeleteCanal(item._id)}
                    botao={() => {
                      if (item.platform === "instagram" || item.platform === "whatsapp_business") {
                        onConnect()
                      } else {
                        navigate({
                          pathname: '/dashboard/configuracoes/conectar-whatsapp',
                          search: '?channelId=' + item._id
                        });
                      }
                    }}
                    fbLogin={
                      <button
                        className="w-full bg-[#1877f2] text-white px-4 py-2.5 rounded-xl text-sm font-semibold flex items-center justify-center gap-2 hover:bg-[#166fe5] transition-all"
                        onClick={() => onButtonLoginFacebook(item)}
                      >
                        <Iconify icon="bi:facebook" width={20} />
                        <span>Conectar Facebook</span>
                      </button>
                    }
                    onConfig={() => {
                      navigate({
                        pathname: '/dashboard/configuracoes/channelDetails',
                        search: '?channelId=' + item._id
                      })
                    }}
                    canal={item}
                    onDesconectar={() => handleDesconectarCanal(item._id)}
                    onDesvincular={() => handleDesvincularCanal(item._id)}
                  />
                ))}
              </div>
            ) : (
              <div className="w-full border rounded-xl overflow-hidden bg-white shadow-sm">
                <GenericTable headLabels={TABLE_HEAD}>
                  {listaCanais && listaCanais.map((item) => {
                    const isConnected = item.status_connection_whatsapp === "conectado";
                    return (
                      <div key={item._id} className={GENERIC_TABLE_DESIGN.row.container}>
                        {/* Name */}
                        <div className={GENERIC_TABLE_DESIGN.common.colMain}>
                          <div className="flex items-center gap-3">
                            <div className="p-2 rounded-lg bg-gray-50 text-gray-600">
                              {item.platform === "whatsapp" && <Iconify icon="logos:whatsapp-icon" width={24} height={24} />}
                              {item.platform === "whatsapp_business" && <Iconify icon="hugeicons:whatsapp-business" width={24} height={24} color="#25D366" />}
                              {item.platform === "instagram" && <Iconify icon="skill-icons:instagram" width={24} height={24} />}
                              {item.platform === "messenger" && <Iconify icon="logos:messenger" width={24} height={24} />}
                              {!["whatsapp", "whatsapp_business", "instagram", "messenger"].includes(item.platform) && (
                                <div className="w-6 h-6 bg-gray-200 rounded-full" />
                              )}
                            </div>
                            <div>
                              <h3 className="text-sm font-semibold text-gray-900">{item.nome}</h3>
                            </div>
                          </div>
                        </div>

                        {/* Platform / Details */}
                        <div className="flex-1 px-4">
                          {item.platform === "whatsapp" && (
                            <div className="flex items-center gap-2">
                              <span className="text-sm text-gray-600 font-medium">
                                {formataNumeroCelular(item.numero_whatsapp)}
                              </span>
                            </div>
                          )}
                          {item.platform === "whatsapp_business" && (
                            <div className="flex flex-col">
                              <span className="text-xs text-gray-500">WABA ID</span>
                              <span className="text-sm text-gray-700 font-mono">{item.config?.meta?.whatsappBusinness?.wabaId || '-'}</span>
                            </div>
                          )}
                          {/* Add other platform details as needed */}
                        </div>

                        {/* Status */}
                        <div className="w-32 flex justify-center">
                          <Chip
                            label={isConnected ? "Conectado" : "Desconectado"}
                            color={isConnected ? "success" : "error"}
                            size="small"
                            variant="soft"
                            sx={{
                              bgcolor: isConnected ? 'success.lighter' : 'error.lighter',
                              color: isConnected ? 'success.main' : 'error.main',
                              fontWeight: 600
                            }}
                          />
                        </div>

                        {/* Actions */}
                        <div className="flex justify-end items-center gap-2 min-w-[120px]">
                          {item.platform === "instagram" && !isConnected && (
                            <button
                              className="p-1.5 rounded-lg text-blue-600 hover:bg-blue-50 transition-colors"
                              onClick={() => onButtonLoginFacebook(item)}
                              title="Conectar Facebook"
                            >
                              <Iconify icon="bi:facebook" width={20} height={20} />
                            </button>
                          )}

                          {item.platform === "whatsapp" && !isConnected && (
                            <button
                              className="p-1.5 rounded-lg text-green-600 hover:bg-green-50 transition-colors"
                              onClick={() => {
                                if (item.platform === "whatsapp_business") {
                                  onConnect();
                                } else {
                                  navigate({
                                    pathname: '/dashboard/configuracoes/conectar-whatsapp',
                                    search: '?channelId=' + item._id
                                  });
                                }
                              }}
                              title="Conectar WhatsApp"
                            >
                              <Iconify icon="solar:link-circle-bold" width={20} height={20} />
                            </button>
                          )}

                          {verifyRules(user.rules, "editar_canal") && (
                            <button
                              onClick={() => {
                                navigate({
                                  pathname: '/dashboard/configuracoes/channelDetails',
                                  search: '?channelId=' + item._id
                                })
                              }}
                              className="p-1.5 rounded-lg text-gray-600 hover:bg-gray-100 transition-colors"
                              title="Configurar"
                            >
                              <Iconify icon="solar:settings-bold" width={20} height={20} />
                            </button>
                          )}

                          {item.platform === "whatsapp" && (
                            <button
                              className="p-1.5 rounded-lg text-red-600 hover:bg-red-50 transition-colors"
                              onClick={() => handleDesconectarCanal(item._id)} // Simplify for table view, ideally show modal
                              title="Sair"
                            >
                              <Iconify icon="solar:logout-2-bold" width={20} height={20} />
                            </button>
                          )}

                          {user.clienteId !== item.cliente_id && verifyRules(user.rules, "editar_canal") && (
                            <button
                              className="p-1.5 rounded-lg text-red-600 hover:bg-red-50 transition-colors"
                              onClick={() => setCanalToDelete(item)}
                              title="Excluir"
                            >
                              <Iconify icon="solar:trash-bin-trash-bold" width={20} height={20} />
                            </button>
                          )}
                        </div>
                      </div>
                    );
                  })}
                  {/* Row for New Channel in Table View? Usually tables list existing items. 
                             Perhaps we keep the "New Channel" button in the header as the primary way to add.
                         */}
                </GenericTable>
              </div>
            )}
          </>
        )}
      </div>

      {canalToDelete && (
        <div className="fixed inset-0 bg-gray-900/40 backdrop-blur-sm flex items-center justify-center z-50 animate-in fade-in duration-200">
          <div className="bg-white rounded-xl p-6 max-w-sm w-full mx-4 shadow-xl border border-gray-100" onClick={(e) => e.stopPropagation()}>
            <div className="flex flex-col items-center text-center mb-6">
              <div className="w-12 h-12 bg-red-50 rounded-full flex items-center justify-center mb-4 text-red-500">
                <Iconify icon="solar:trash-bin-trash-bold" width={24} height={24} />
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">Excluir Canal?</h3>
              <p className="text-sm text-gray-500 leading-relaxed">
                Você esta prestes a remover <strong>"{canalToDelete.nome}"</strong>. Isso removerá todos os dados vinculados permanentemente.
              </p>
            </div>

            <div className="flex space-x-3">
              <button
                className="flex-1 px-4 py-2.5 text-sm font-medium text-gray-700 bg-gray-50 rounded-xl hover:bg-gray-100 transition-colors"
                onClick={() => setCanalToDelete(null)}
              >
                Cancelar
              </button>
              <button
                className="flex-1 px-4 py-2.5 text-sm font-medium text-white bg-red-600 rounded-xl hover:bg-red-700 transition-colors shadow-sm"
                onClick={() => {
                  handleDeleteCanal(canalToDelete._id);
                  setCanalToDelete(null);
                }}
              >
                Excluir
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}


const CardNewChannel = ({ onClick, disabled, blockReason }) => {
  return (
    <button
      onClick={disabled ? null : onClick}
      disabled={disabled}
      title={disabled ? (blockReason || '') : ''}
      className={`
        group relative flex flex-col items-center justify-center p-6 rounded-xl
        border-2 border-dashed transition-all duration-300 min-h-[240px] w-full
        animate-in fade-in slide-in-from-bottom-2 duration-300
        ${disabled
          ? 'border-gray-200 bg-gray-50 opacity-60 cursor-not-allowed'
          : 'border-[#7C3AED]/30 bg-[#7C3AED]/5 hover:bg-[#7C3AED]/10 hover:border-[#7C3AED]/50 cursor-pointer'
        }
      `}
    >
      <div className={`
        w-14 h-14 rounded-lg flex items-center justify-center mb-3 transition-all duration-300
        ${disabled
          ? 'bg-gray-100 text-gray-400'
          : 'bg-white text-[#7C3AED] shadow-sm group-hover:scale-110 group-hover:shadow-md'
        }
      `}>
        <Iconify icon="solar:add-circle-bold" width={32} height={32} />
      </div>

      <h3 className={`text-base font-semibold mb-1 ${disabled ? 'text-gray-400' : 'text-[#7C3AED]'}`}>
        Novo Canal
      </h3>

      <p className="text-sm text-center px-4 text-gray-500 leading-relaxed">
        {disabled ? blockReason : 'Adicione contas de WhatsApp Business'}
      </p>
    </button>
  );
}


function CanalCard({ user, canal, botao, onConfig, fbLogin, onDelete, onDesvincular, onDesconectar }) {
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showDisconnectModal, setShowDisconnectModal] = useState(false);

  function formatIcons(key) {
    switch (key) {
      case "whatsapp":
        return <Iconify icon="logos:whatsapp-icon" width={28} height={28} />

      case "whatsapp_business":
        return <Iconify icon="hugeicons:whatsapp-business" width={28} height={28} color="#25D366" />
      case "instagram":
        return <Iconify icon="skill-icons:instagram" width={28} height={28} />
      case "messenger":
        return <Iconify icon="logos:messenger" width={28} height={28} />
      default:
        return <div className="w-7 h-7 bg-gray-100 rounded-full" />
    }
  }

  const handleDeleteConfirm = () => {
    onDelete();
    setShowDeleteModal(false);
  };

  const handleDisconnectConfirm = () => {
    onDesconectar();
    setShowDisconnectModal(false);
  };

  return (
    <>
      <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-5 relative flex flex-col h-full min-h-[240px] hover:shadow-md hover:border-[#7C3AED]/30 transition-all duration-300 animate-in fade-in slide-in-from-bottom-2 duration-300">

        {/* Header Actions */}
        <div className="absolute top-4 right-4 flex items-center gap-2 z-10">
          {canal.platform === "whatsapp" && (
            <div className={`
                    w-2.5 h-2.5 rounded-full shadow-sm ring-2 ring-white
                    ${canal.status_connection_whatsapp === "conectado" ? "bg-green-500" : "bg-red-500"}
                 `} title={canal.status_connection_whatsapp === "conectado" ? "Conectado" : "Desconectado"} />
          )}

          {/* Botão de Excluir */}
          {user.clienteId !== canal.cliente_id && verifyRules(user.rules, "editar_canal") && (
            <button
              className="p-1.5 rounded-lg text-gray-400 hover:text-red-500 hover:bg-red-50 transition-all opacity-0 group-hover:opacity-100 pointer-events-none group-hover:pointer-events-auto"
              onClick={(e) => { e.stopPropagation(); setShowDeleteModal(true); }}
              title="Remover canal"
            >
              <Iconify icon="solar:trash-bin-trash-bold" width={18} height={18} />
            </button>
          )}
        </div>

        {/* Content */}
        <div className="flex-1 flex flex-col items-center pt-2 group">
          {/* Icon with subtle background */}
          <div className="mb-3 p-3 bg-gray-50 rounded-lg group-hover:scale-105 transition-transform duration-300">
            {formatIcons(canal.platform)}
          </div>

          <h3 className="text-sm font-semibold text-gray-900 text-center line-clamp-1 mb-1 px-2" title={canal.nome}>
            {canal.nome}
          </h3>

          {canal.platform === "whatsapp" && (
            <p className="text-[11px] text-gray-500 mb-4 bg-gray-50 px-2.5 py-0.5 rounded-full font-medium tracking-wide">
              {formataNumeroCelular(canal.numero_whatsapp)}
            </p>
          )}

          {!canal.platform.includes('whatsapp') && (
            <div className="h-8 mb-4"></div>
          )}

          <div className="w-full mt-auto space-y-3">
            <div className="h-px bg-gradient-to-r from-transparent via-gray-100 to-transparent w-full mb-4" />

            {canal.platform === "instagram" && (
              canal.status_connection_whatsapp === "conectado" ? (
                <div className="w-full">
                  {fbLogin}
                </div>
              ) : (
                <div className="w-full">{fbLogin}</div>
              )
            )}

            {canal.platform === "whatsapp" && (
              canal.status_connection_whatsapp !== "conectado" && (
                <button
                  className="w-full bg-[#7C3AED] text-white px-3 py-2 rounded-lg text-xs font-semibold hover:bg-[#6D28D9] transition-all shadow-sm shadow-violet-200"
                  onClick={botao}
                >
                  Conectar WhatsApp
                </button>
              )
            )}

            <div className="grid grid-cols-2 gap-2 w-full">
              {verifyRules(user.rules, "editar_canal") && (
                <button
                  className="flex-1 flex items-center justify-center gap-1.5 bg-gray-50 text-gray-700 px-3 py-2 rounded-lg text-xs font-semibold hover:bg-gray-100 hover:text-gray-900 transition-all"
                  onClick={onConfig}
                >
                  <Iconify icon="solar:settings-bold" width={16} height={16} />
                  <span>Configurar</span>
                </button>
              )}

              {canal.platform === "whatsapp" && (
                <button
                  className="flex-1 flex items-center justify-center gap-1.5 bg-red-50 text-red-600 px-3 py-2 rounded-lg text-xs font-semibold hover:bg-red-100 transition-all"
                  onClick={() => setShowDisconnectModal(true)}
                >
                  <Iconify icon="solar:logout-2-bold" width={16} height={16} />
                  <span>Sair</span>
                </button>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Delete Confirmation Modal */}
      {showDeleteModal && (
        <div className="fixed inset-0 bg-gray-900/40 backdrop-blur-sm flex items-center justify-center z-50 animate-in fade-in duration-200">
          <div className="bg-white rounded-xl p-6 max-w-sm w-full mx-4 shadow-xl border border-gray-100" onClick={(e) => e.stopPropagation()}>
            <div className="flex flex-col items-center text-center mb-6">
              <div className="w-12 h-12 bg-red-50 rounded-full flex items-center justify-center mb-4 text-red-500">
                <Iconify icon="solar:trash-bin-trash-bold" width={24} height={24} />
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">Excluir Canal?</h3>
              <p className="text-sm text-gray-500 leading-relaxed">
                Você esta prestes a remover <strong>"{canal.nome}"</strong>. Isso removerá todos os dados vinculados permanentemente.
              </p>
            </div>

            <div className="flex space-x-3">
              <button
                className="flex-1 px-4 py-2.5 text-sm font-medium text-gray-700 bg-gray-50 rounded-xl hover:bg-gray-100 transition-colors"
                onClick={() => setShowDeleteModal(false)}
              >
                Cancelar
              </button>
              <button
                className="flex-1 px-4 py-2.5 text-sm font-medium text-white bg-red-600 rounded-xl hover:bg-red-700 transition-colors shadow-sm"
                onClick={handleDeleteConfirm}
              >
                Excluir
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Disconnect Confirmation Modal */}
      {showDisconnectModal && (
        <div className="fixed inset-0 bg-gray-900/40 backdrop-blur-sm flex items-center justify-center z-50 animate-in fade-in duration-200">
          <div className="bg-white rounded-xl p-6 max-w-sm w-full mx-4 shadow-xl border border-gray-100" onClick={(e) => e.stopPropagation()}>
            <div className="flex flex-col items-center text-center mb-6">
              <div className="w-12 h-12 bg-orange-50 rounded-full flex items-center justify-center mb-4 text-orange-500">
                <Iconify icon="solar:logout-2-bold" width={24} height={24} />
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">Desconectar Canal?</h3>
              <p className="text-sm text-gray-500 leading-relaxed">
                Deseja desconectar <strong>"{canal.nome}"</strong>? Será necessário escanear o QR Code novamente para reconectar.
              </p>
            </div>

            <div className="flex space-x-3">
              <button
                className="flex-1 px-4 py-2.5 text-sm font-medium text-gray-700 bg-gray-50 rounded-xl hover:bg-gray-100 transition-colors"
                onClick={() => setShowDisconnectModal(false)}
              >
                Cancelar
              </button>
              <button
                className="flex-1 px-4 py-2.5 text-sm font-medium text-white bg-orange-500 rounded-xl hover:bg-orange-600 transition-colors shadow-sm"
                onClick={handleDisconnectConfirm}
              >
                Desconectar
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
